module.exports = __webpack_public_path__ + "img/engraving@2x.852485a.webp";